import { useRouteError } from "react-router-dom";
import styles from "@/pages/error-boundary/styles.scss";
import { ErrorScreen } from "@/components";

export const ErrorBoundary = () => {
  const error = useRouteError();

  // eslint-disable-next-line no-console
  console.error("Uncaught error:", error);

  return (
    <ErrorScreen
      titleClassName={styles.errorTitle}
      subtitleClassName={styles.errorSubTitle}
    />
  );
};
